export const DEFAULT_IPFS_GATEWAY = 'https://ipfs.eth.aragon.network';
export const NETWORKS = [
    {
        chainId: 1,
        name: 'ethereum',
        ensAddress: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
    },
    {
        chainId: 4,
        name: 'rinkeby',
        ensAddress: '0x98df287b6c145399aaa709692c8d308357bc085d',
    },
    {
        chainId: 100,
        name: 'xdai',
        ensAddress: '0xaafca6b0c89521752e559650206d7c925fd0e530',
    },
];
//# sourceMappingURL=params.js.map